import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

export interface RestrictedBrowserDialogData {
  appName?: string | null;
  isIos?: boolean;
}

@Component({
  selector: 'app-facebook-browser-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    MatButton,
  ],
  template: `
    <h2 mat-dialog-title class="flex items-center gap-2">
      <mat-icon color="warn">info</mat-icon>
      Open Playble in your browser
    </h2>
    <mat-dialog-content class="space-y-3">
      <p>
        {{ appName }}'s in-app browser blocks access to the device Geolocation API, so we can't automatically detect your
        location here.
      </p>
      <p class="text-sm text-slate-600 dark:text-slate-300">
        @if (isIos) {
          On iPhone, tap the ⋯ or Share menu and choose <strong>Open in Safari</strong>. Home Screen Playble also has its own
          Location Services entry under Settings, and Precise Location should be on.
        } @else {
          Tap the ⋯ menu and choose <strong>Open in Chrome</strong> or <strong>Open in browser</strong>.
        }
        You can continue without sharing your location, but listings will use Brisbane as a labelled default.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-stroked-button mat-dialog-close color="primary">Got it</button>
    </mat-dialog-actions>
  `
})
export class FacebookBrowserDialog {
  private data = inject<RestrictedBrowserDialogData | null>(MAT_DIALOG_DATA, {optional: true});

  get appName(): string {
    return this.data?.appName || 'This';
  }

  get isIos(): boolean {
    return this.data?.isIos === true;
  }
}
